import { Router } from '@angular/router';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NotificationsService } from '@vestiaire/api-sdk-angular';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import * as HeaderActions from '@app/core/header/store/actions/header.action';
import { MatDialog } from '@angular/material/dialog';
import { MmaoPopinComponent } from '@app/shared/components/mmao/mmao-popin/mmao-popin.component';
import { MmaoService } from '@app/shared/components/mmao/services/mmao.service';

@Component({
  selector: 'vc-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NotificationItemComponent implements OnInit {
  @Input()
  notification: any;

  constructor(
    private router: Router,
    private notificationsService: NotificationsService,
    private store: Store<IAppState>,
    private mmaoService: MmaoService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {}

  /**
   * @param notification
   *
   * @todo Fix the spec so that the notification model is corresponding to the response sent by Atlas.
   * Actually it miss `relationships` property of the notification model.
   */
  loadUrl(notification) {
    this.mmaoService.hideNotifications.next(true);
    if (notification.clickable && !notification.clicked) {
      this.updateNotificationStatus(notification.id);
    }
    if (notification.relationships && notification.relationships.negotiation) {
      this.openNegotiatingArea(notification.relationships.negotiation.data);
    } else {
      const urlTree = this.router.parseUrl(notification.link);
      const fragment = urlTree.fragment;
      const queryParams = urlTree.queryParams;
      // Set absolute URL for obfuscated links.
      urlTree.fragment = null;
      urlTree.queryParams = {};
      let path = this.router.serializeUrl(urlTree);
      // Special case of Homepage route.
      // Angular router expects an empty path instead of `/`.
      if (path === '/') {
        path = '';
      }
      const commands = [path];
      this.router.navigate(commands, { fragment, queryParams });
    }
  }

  /**
   * Opens the negotiating area in a dialog popin.
   *
   * @param data Negotiation data
   */
  openNegotiatingArea(data: { id: string; type: 'negotiation' }): void {
    this.mmaoService.getNegotiation(data.id).subscribe(
      negotiation => {
        this.dialog.open(MmaoPopinComponent, {
          maxWidth: 600,
          data: {
            product: negotiation.product,
            negotiation: negotiation
          }
        });
      },
      err => console.log(err)
    );
  }

  updateNotificationStatus(id) {
    this.notificationsService.updateNotification(id, { viewed: true }).subscribe(
      result => {
        if (result) {
          this.store.dispatch({
            type: HeaderActions.SET_COUNTERS_NOTIFICATIONS_RESET
          });
          this.notification.clicked = true;
        }
      },
      () => {
        /* Silently catch exception */
      }
    );
  }
}
